import { useState, useEffect } from "react";

let _cache = null;
let _promise = null;

function fetchAll() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch("/api/site-content.php")
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => { _cache = d; return d; })
      .catch(() => { _promise = null; return {}; });
  }
  return _promise;
}

export function useSiteContent(pageKey, defaults) {
  const [data, setData] = useState(defaults);
  useEffect(() => {
    fetchAll().then((all) => {
      if (all[pageKey] && Object.keys(all[pageKey]).length > 0) {
        setData((prev) => ({ ...prev, ...all[pageKey] }));
      }
    });
  }, [pageKey]);
  return data;
}
